export function addPastEventsFilters(filtersString, timestamp) {
  return (
    `(isAnEvent = 0 OR endTimestamp > ${timestamp} OR startTimestamp > ${timestamp})` +
    (filtersString ? ` AND ${filtersString}` : '')
  );
}

export function addPrivateGroupsFilters(filtersString, privateGroupIds) {
  return (
    '(isPublic:1' +
    privateGroupIds.map(groupId => ` OR privateGroupId:${groupId}`).join('') +
    ')' +
    (filtersString ? ` AND ${filtersString}` : '')
  );
}

export function addCourseVisibilityFilters(filtersString, courseVisibility) {
  const baseFilter = 'NOT types:course OR courseVisibility:all';

  if (courseVisibility.length === 0) {
    return `(${baseFilter})${filtersString ? ` AND ${filtersString}` : ''}`;
  }

  const visibilityFilter = courseVisibility
    .map(visibility => ` OR courseVisibility:${visibility}`)
    .join('');

  return `(${baseFilter}${visibilityFilter})${
    filtersString ? ` AND ${filtersString}` : ''
  }`;
}

export function generateAlgoliaFilters(
  filters,
  privateGroupIds,
  courseVisibility,
  timestamp
) {
  let filtersQueryString = filtersToQueryString(filters);

  filtersQueryString = addPrivateGroupsFilters(
    filtersQueryString,
    privateGroupIds
  );

  filtersQueryString = addCourseVisibilityFilters(
    filtersQueryString,
    courseVisibility
  );

  return filtersQueryString;
}

export const nonAlgoliaFilters = ['onlyShowFutureEvents'];

export default function filtersToQueryString(
  filters,
  defaultFilters = {},
  isForAlgolia = true
) {
  let notDefaultFilters = { ...filters };

  for (let [defaultFilterName, defaultFilterValue] of Object.entries(
    defaultFilters
  )) {
    if (!filters[defaultFilterName]) {
      continue;
    }

    if (filters[defaultFilterName].length !== defaultFilterValue.length) {
      continue;
    }

    let index = 0;
    let filterAndDefaultFilterValueAreEquals = true;
    for (let defaultFilterValueItem of defaultFilterValue) {
      if (filters[defaultFilterName][index] !== defaultFilterValueItem) {
        filterAndDefaultFilterValueAreEquals = false;
        break;
      }
      index += 1;
    }

    if (!filterAndDefaultFilterValueAreEquals) {
      continue;
    }

    delete notDefaultFilters[defaultFilterName];
  }

  let queryString = Object.entries(notDefaultFilters)
    .map(filter => {
      const [filterName, filterValues] = filter;
      if (isForAlgolia && nonAlgoliaFilters.includes(filterName)) {
        return '';
      }

      if (!isForAlgolia && filterValues.length === 0) {
        return `${filterName}:`;
      }

      return filterValues
        .map(filterValue => {
          return `${filterName}:${filterValue}`;
        })
        .join(' OR ');
    })
    .filter(filerString => filerString !== '')
    .map(filterString => {
      return filterString.includes(' OR ') ? `(${filterString})` : filterString;
    })
    .join(' AND ');

  if (
    queryString.startsWith('(') &&
    queryString.endsWith(')') &&
    !queryString.includes('AND')
  ) {
    queryString = queryString.substr(1, queryString.length - 2);
  }

  return queryString;
}
